// src/components/modals/permissionsDefaults.js

// ✅ Shared dropdown constants
export const TIMEZONES = [
  "Asia/Kolkata",
  "Asia/Dubai",
  "Asia/Kathmandu",
  "Asia/Dhaka",
  "UTC",
];

export const LANGUAGES = [
  { value: "en", label: "English" },
  { value: "hi", label: "Hindi" },
];

export const UNITS = {
  speed: ["km/h", "mph"],
  distance: ["km", "miles", "meters"],
  altitude: ["meters", "feet"],
  volume: ["Liter", "Gallon", "ml"],
};

// ✅ Dealer permissions schema (used by Dealer + SubAdmin)
export const dealerPermissionsSchema = [
  {
    title: "Device permission",
    key: "device",
    items: [
      { key: "add", label: "Add" },
      { key: "disable", label: "Disable Device" },
      { key: "edit", label: "Edit" },
      { key: "delete", label: "Delete" },
      { key: "renew", label: "Renew" },
    ],
  },
  {
    title: "User permission",
    key: "user",
    items: [
      { key: "add", label: "Add" },
      { key: "dealer", label: "Dealer permission" },
      { key: "edit", label: "Edit" },
      { key: "delete", label: "Delete" },
    ],
  },
  {
    title: "Notification permission",
    key: "notification",
    items: [{ key: "add", label: "Add" }],
  },
  {
    title: "Data push permission",
    key: "dataPush",
    items: [{ key: "allow", label: "Allow" }],
  },
  {
    title: "Sensors permission",
    key: "sensors",
    items: [{ key: "allow", label: "Allow" }],
  },
  {
    title: "Summary edit permission",
    key: "summaryEdit",
    items: [{ key: "allow", label: "Allow" }],
  },
  {
    title: "No of device textbox permission",
    key: "deviceTextbox",
    items: [{ key: "allow", label: "Allow" }],
  },
  {
    title: "Other",
    key: "other",
    items: [
      { key: "disabled", label: "Disabled" },
      { key: "limitCommands", label: "Limit Commands" },
      { key: "readonly", label: "Readonly" },
      { key: "disableReports", label: "Disable Reports" },
      {
        key: "dontUseDealerLicense",
        label: "Don’t use dealer’s license when device is assigned to dealer",
      },
      { key: "deviceReadonly", label: "Device Readonly" },
      { key: "stopParkingAlerts", label: "Stop parking alerts" },
    ],
  },
];

export const subAdminPermissionsSchema = [
  dealerPermissionsSchema[0],
  dealerPermissionsSchema[1],
  {
    title: "Dealer permission",
    key: "dealer",
    items: [
      { key: "add", label: "Add" },
      { key: "edit", label: "Edit" },
      { key: "delete", label: "Delete" },
      { key: "renew", label: "Renew" },
      { key: "assign", label: "Assign" },
    ],
  },
  ...dealerPermissionsSchema.slice(2),
];

// ✅ Basic end-user schema (kept as-is)
export const userPermissionsSchema = [
  {
    title: "Permissions",
    key: "user",
    items: [{ key: "hideValidity", label: "Hide Validity" }],
  },
];

// ✅ Default preferences
export const defaultPreferences = {
  speedUnit: "km/h",
  distanceUnit: "km",
  altitudeUnit: "meters",
  volumeUnit: "Liter",
  timeZone: "Asia/Kolkata",
  language: "en",
};

// ✅ Default Dealer permissions
export const defaultDealerPermissions = {
  device: { add: true, disable: false, edit: true, delete: false, renew: false },
  user: { add: true, dealer: true, edit: true, delete: true },
  notification: { add: true },
  dataPush: { allow: true },
  sensors: { allow: true },
  summaryEdit: { allow: true },
  deviceTextbox: { allow: true },
  other: {
    disabled: false,
    limitCommands: false,
    readonly: false,
    disableReports: false,
    dontUseDealerLicense: false,
    deviceReadonly: false,
    stopParkingAlerts: false,
  },
  limits: {
    deviceLimit: 0,
    userLimit: 5,
  },
};

// ✅ Default User permissions
export const defaultUserPermissions = {
  user: { hideValidity: false },
};

// ✅ Normalize uniqueId / userId
export const normalizeUserId = (value = "") =>
  value
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "")
    .replace(/[^a-z0-9._-]/g, "");

// ─────────────────────────────────────────────────────────────
// ✅ Sub Admin support (FIX for your build errors)
// ─────────────────────────────────────────────────────────────

export const defaultSubAdminPermissions = {
  ...defaultDealerPermissions,
  dealer: {
    add: true,
    edit: true,
    delete: true,
    renew: false,
    assign: true,
  },
};
